module.exports = __webpack_public_path__ + "static/media/indian-expres.253bcc7c.svg";